import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectId/plan/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/projects/$projectId/plan/stages', params, replace: true });
  },
});
